module.exports = __webpack_public_path__ + "static/media/image_15.631d9192.png";